import { motion } from "framer-motion";
import SectionHead from "@/components/SectionHead";
import { scopeNodes } from "@/data/content";

const accents = {
  yellow: "bg-gradient-to-br from-amberx to-yellow-400 text-ink",
  blue: "bg-gradient-to-br from-turq to-eblue text-white",
  neutral: "bg-elevated/80 text-slate-200 border border-white/10",
};

const HexNode = ({ node, i }) => (
  <motion.div
    data-testid={`scope-hexagon-node-${node.id}`}
    initial={{ opacity: 0, scale: 0.7 }}
    whileInView={{ opacity: 1, scale: 1 }}
    viewport={{ once: true, margin: "-40px" }}
    transition={{ type: "spring", stiffness: 200, damping: 18, delay: i * 0.12 }}
    whileHover={{ scale: 1.08, rotate: i % 2 === 0 ? 2 : -2 }}
    className={`hex-clip relative flex items-center justify-center text-center w-44 h-[152px] sm:w-52 sm:h-[180px] px-6 cursor-default ${accents[node.accent]}`}
  >
    <span className="font-syne text-sm sm:text-base font-bold leading-snug">{node.title}</span>
  </motion.div>
);

export default function Scope() {
  const rows = [scopeNodes.slice(0, 3), scopeNodes.slice(3, 5), scopeNodes.slice(5)];
  let idx = 0;
  return (
    <section id="scope" data-testid="scope-section" className="relative py-28 sm:py-36 overflow-hidden">
      <div
        className="pointer-events-none absolute inset-0 opacity-40"
        style={{
          background:
            "radial-gradient(circle at 50% 50%, rgba(37,99,235,0.12) 0%, rgba(11,15,23,0) 60%)",
        }}
      />
      <div className="relative max-w-7xl mx-auto px-5 sm:px-8">
        <SectionHead eyebrow="Our Scope" title={<>Talent <span className="text-gradient">×</span> Marka İş Birliği</>} testId="scope-title" />

        {/* Desktop honeycomb */}
        <div className="hidden md:flex flex-col items-center -space-y-6">
          {rows.map((row, r) => (
            <div key={r} className="flex gap-6">
              {row.map((node) => {
                const el = <HexNode key={node.id} node={node} i={idx} />;
                idx += 1;
                return el;
              })}
            </div>
          ))}
        </div>

        {/* Mobile readable stack */}
        <div className="md:hidden flex flex-col items-center gap-4">
          {scopeNodes.map((node, i) => (
            <motion.div
              key={node.id}
              data-testid={`scope-mobile-node-${node.id}`}
              initial={{ opacity: 0, x: -20 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: i * 0.08 }}
              className={`w-full max-w-sm rounded-xl px-6 py-4 flex items-center gap-4 ${accents[node.accent]}`}
            >
              <span className="font-syne text-xs opacity-60">0{i + 1}</span>
              <span className="font-syne text-base font-bold">{node.title}</span>
            </motion.div>
          ))}
        </div>

        <motion.p
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true }}
          transition={{ delay: 0.4 }}
          className="mt-16 text-center text-slate-400 text-sm sm:text-base max-w-2xl mx-auto leading-relaxed"
        >
          Doğru eşleşmeden ölçümlemeye — marka ve talent arasındaki her adım, tek bir ekosistemde
          tasarlanır ve yönetilir.
        </motion.p>
      </div>
    </section>
  );
}
